// cy.js
import React, { useRef, useEffect, useState, useLayoutEffect } from "react";
import cytoscape from "cytoscape";
import fcose from "cytoscape-fcose";
import CytoscapeComponent from "react-cytoscapejs";
import cxtmenu from "cytoscape-cxtmenu";
import openFloatingModal from "./openFloatingModal";
import StudentButton from "./StudentButton";
import { Button } from "react-bootstrap";
import  getGPAColor  from "./getGPAColor";
import LogPanel from "./LogPanel";
import { HandEyeIcon, FoldersIcon } from "@phosphor-icons/react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import ThreeDGraph from "./ThreeDGraph";
import cytoscapeGraphml from "cytoscape-graphml";
import { ClusterDashboard } from "./ClusterDashboard.jsx";
import { XCircleIcon } from "@phosphor-icons/react";
var spread = require("cytoscape-spread");

spread(cytoscape)
cytoscape.use(cxtmenu);
cytoscape.use(fcose);
cytoscape.use(cytoscapeGraphml);
cytoscape.warnings(false);

 function SectionHeader({ open, onToggle, title }) {
    return (
      <Dropdown.Item
        as="button"
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation(); // keep dropdown open
          onToggle();
        }}
        style={{
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <span>{title}</span>
        <span style={{ marginLeft: 10 }}>{open ? "▾" : "▸"}</span>
      </Dropdown.Item>
    );
  }

  function ExportDropdown({  downloadCyFullJson,
      downloadCyElementsJson,       
      downloadCyGraphML,
      downloadCyVisibleElementsJson,
      downloadCyVisibleGraphML,
      downloadElementsGraphML,
      downloadElementsJson, elements,
        cyInstance, downloadCsv }) {
    const [openCsv, setOpenCsv] = useState(false);
    const [openGraph, setOpenGraph] = useState(false);

    return (
      <Dropdown as={ButtonGroup} autoClose="outside">
        <Button
          variant="primary"
          className="btn btn-primary"
          size="md"
          onClick={() => downloadCsv("groups")} // original default
        >
          Export
        </Button>

        <Dropdown.Toggle
          split
          variant="primary"
          className="btn btn-primary"
          id="export-split"
        />

        <Dropdown.Menu style={{ minWidth: 360, maxHeight: "40vh", overflowY: "auto" }}>
          {/* ===================== CSV SECTION ===================== */}
          <SectionHeader
            title="Download CSV"
            open={openCsv}
            onToggle={() => setOpenCsv((v) => !v)}
          />

          {openCsv && (
            <>
              <Dropdown.Item onClick={() => downloadCsv({ mode: "students", scope: "all" })}>
                All Data (group + subject + kmeans)
              </Dropdown.Item>

              <Dropdown.Divider />
              <Dropdown.Header>Groups</Dropdown.Header>

              <Dropdown.Item onClick={() => downloadCsv({ mode: "groups", scope: "compiled" })}>
                Compiled (all groups in one CSV)
              </Dropdown.Item>
              <Dropdown.Item onClick={() => downloadCsv({ mode: "groups", scope: "partitioned" })}>
                Partitioned (one CSV per group)
              </Dropdown.Item>
              <Dropdown.Item onClick={() => downloadCsv({ mode: "groups", scope: "dataset" })}>
                Dataset export (groups table)
              </Dropdown.Item>

              <Dropdown.Divider />
              <Dropdown.Header>Subjects</Dropdown.Header>

              <Dropdown.Item onClick={() => downloadCsv({ mode: "subjects", scope: "compiled" })}>
                Compiled (all subjects in one CSV)
              </Dropdown.Item>
              <Dropdown.Item onClick={() => downloadCsv({ mode: "subjects", scope: "partitioned" })}>
                Partitioned (one CSV per subject)
              </Dropdown.Item>
              <Dropdown.Item onClick={() => downloadCsv({ mode: "subjects", scope: "dataset" })}>
                Dataset export (subjects table)
              </Dropdown.Item>

              <Dropdown.Divider />
              <Dropdown.Header>KMeans</Dropdown.Header>

              <Dropdown.Item onClick={() => downloadCsv({ mode: "kmeans", scope: "compiled" })}>
                Compiled (all clusters in one CSV)
              </Dropdown.Item>
              <Dropdown.Item onClick={() => downloadCsv({ mode: "kmeans", scope: "partitioned" })}>
                Partitioned (one CSV per cluster)
              </Dropdown.Item>
              <Dropdown.Item onClick={() => downloadCsv({ mode: "kmeans", scope: "dataset" })}>
                Dataset export (kmeans table)
              </Dropdown.Item>
            </>
          )}

          <Dropdown.Divider />

          {/* ===================== GRAPH SECTION ===================== */}
          <SectionHeader
            title="Download Graph (GraphML / JSON)"
            open={openGraph}
            onToggle={() => setOpenGraph((v) => !v)}
          />

          {openGraph && (
            <>
              <Dropdown.Header>JSON</Dropdown.Header>

              <Dropdown.Item onClick={() => downloadElementsJson(elements, "elements.json")}>
                Elements JSON (props)
              </Dropdown.Item>

              <Dropdown.Item onClick={() => downloadCyElementsJson(cyInstance, "elements_cy.json")}>
                Elements JSON (cy.elements().jsons())
              </Dropdown.Item>

              <Dropdown.Item onClick={() => downloadCyFullJson(cyInstance, "cy_full.json")}>
                Full Cytoscape JSON (cyInstance.json())
              </Dropdown.Item>

              <Dropdown.Item onClick={() => downloadCyVisibleElementsJson(cyInstance, "elements_visible.json")}>
                Elements JSON (visible only)
              </Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Header>GraphML</Dropdown.Header>

              <Dropdown.Item onClick={() => downloadElementsGraphML(elements, "graph.graphml")}>
                GraphML (minimal, from props)
              </Dropdown.Item>

              <Dropdown.Item onClick={() => downloadCyGraphML(cyInstance, "graph_cy.graphml")}>
                GraphML (cy.graphml() if installed, else fallback)
              </Dropdown.Item>

              <Dropdown.Item onClick={() => downloadCyVisibleGraphML(cyInstance, "graph_visible.graphml")}>
                GraphML (visible only)
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
// -------- utils for clustering (kept from your version) ----------
function l2norm(v){ return Math.sqrt(v.reduce((s,x)=>s+x*x,0)); }
function dot(a,b){ let s=0; for(let i=0;i<a.length;i++) s+=a[i]*b[i]; return s; }
function cosineDistance(a,b){
  const na=l2norm(a), nb=l2norm(b);
  if(na===0||nb===0) return 1;
  const cos = dot(a,b)/(na*nb);
  return 1 - Math.max(-1, Math.min(1, cos));
}
function kmeansVectors(data,k,distance=cosineDistance,maxIter=60){
  const n=data.length; if(n===0||k<1) return {labels:[],centroids:[]};
  const centroids=[]; const used=new Set(); centroids.push(data[0]); used.add(0);
  while(centroids.length<Math.min(k,n)){
    let bestI=-1, bestD=-1;
    for(let i=0;i<n;i++){
      if(used.has(i)) continue;
      const dmin=centroids.reduce((m,c)=>Math.min(m,distance(data[i],c)),Infinity);
      if(dmin>bestD){ bestD=dmin; bestI=i; }
    }
    used.add(bestI); centroids.push(data[bestI]);
  }
  let labels=new Array(n).fill(0);
  for(let iter=0;iter<maxIter;iter++){
    let changed=false;
    for(let i=0;i<n;i++){
      let best=-1, bestD=Infinity;
      for(let c=0;c<centroids.length;c++){
        const d=distance(data[i],centroids[c]);
        if(d<bestD){ bestD=d; best=c; }
      }
      if(labels[i]!==best){ labels[i]=best; changed=true; }
    }
    const dims=data[0].length;
    const sums=Array(centroids.length).fill(0).map(()=>new Array(dims).fill(0));
    const counts=Array(centroids.length).fill(0);
    for(let i=0;i<n;i++){ const kidx=labels[i]; counts[kidx]++; const v=data[i]; for(let d=0;d<dims;d++) sums[kidx][d]+=v[d]; }
    for(let c=0;c<centroids.length;c++){ if(counts[c]>0){ for(let d=0;d<dims;d++) centroids[c][d]=sums[c][d]/counts[c]; } }
    if(!changed) break;
  }
  return {labels,centroids};
}
// cluster helpers
function getClusterBuckets(cy, methodKey){
  const prop = `${methodKey}_clusterId`;
  const buckets = new Map();
  cy.nodes('[type = "student"]').forEach(n=>{
    const cid = n.data(prop);
    if(!cid) return;
    if(!buckets.has(cid)) buckets.set(cid, []);
    buckets.get(cid).push(n);
  });
  return buckets;
}
// ---------------------------------------------------------------

const showConnectionSummary = () => {

}
const CyGraph = ({ networkInfo, groupColors, chartColors, kMeansColors, setLoading, studentData, summary, elements, layout, studentProfile, featureVectors }) => {
  const [cyInstance, setCyInstance] = useState(null);
  const [logs, setLogs] = useState([]);
  const [logPanelOpen, setLogPanelOpen] = useState(true);
  const [panelOpen, setPanelOpen] = useState(false);
  const [summaryPanelOpen, setSummaryPanelOpen] = useState(false);
  const [visibleSummary, setVisibleSummary] = useState();
  const [searchValue, setSearchValue] = useState("");
  const wrapperRef = useRef(null);
  const originalLayoutRef = useRef(null);

  const [visibility, setVisibility] = useState({
    similarity: false,
    kmeans: true,
    subject: false,
    group: false,
    enrollment: false,
    // cluster_kmeans: false,
    // cluster_components: false,
    // cluster_labelprop: false,
  });
  const [nthNeighbor, setNthNeighbor] = useState(1);
  const [featureMode, setFeatureMode] = useState("counts");

  const [params, setParams] = useState({
    similarityThreshold: 0.33,
    layout: { nodeRepulsion: 500000000, idealEdgeLength: 1500, gravity: 0.25 },
    // clustering: {
    //   method: "none",
    //   kMeansK: 6,
    //   labelPropIters: 8,
    //   addGroupNodes: true,
    //   colorByCluster: true,
    // },
  });
  // DROP-IN: export ONLY VISIBLE elements (i.e., not hidden) from Cytoscape
  // Adds two new menu options:
  // - Visible Elements JSON
  // - Visible GraphML
  //
  // "Visible" here means cy elements that are currently rendered (not hidden via cy.hide() or display:none).
  // It also ensures edges are included only if BOTH endpoints are visible.
  
  function getVisibleSubgraphJsons(cy) {
    if (!cy) return [];

    const visNodes = cy.nodes().filter(n => n.visible());
    const visEdges = cy.edges().filter(e => e.visible() && e.source().visible() && e.target().visible());

    return visNodes.union(visEdges).jsons();
  }

  function downloadCyVisibleElementsJson(cy, filename = "elements_visible.json") {
    if (!cy) return;
    const jsons = getVisibleSubgraphJsons(cy);
    triggerDownloadJson(jsons, filename);
  }

  function downloadCyVisibleGraphML(cy, filename = "graph_visible.graphml") {
    if (!cy) return;

    // If graphml plugin exists, we can create a temporary subgraph export:
    // cytoscape-graphml exports the whole graph, so for visible-only we use fallback writer.
    const jsons = getVisibleSubgraphJsons(cy);
    const graphml = elementsToGraphML(jsons);
    triggerDownloadText(graphml, filename, "application/xml;charset=utf-8");
  }
function triggerDownloadText(text, filename, mime = "text/plain;charset=utf-8") {
    const blob = new Blob([text], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  function triggerDownloadJson(obj, filename) {
    triggerDownloadText(JSON.stringify(obj, null, 2), filename, "application/json;charset=utf-8");
  }

  /* ------------------------ Cytoscape -> JSON ------------------------ */

  // elements JSON (array of element JSONs)
  function downloadCyElementsJson(cy, filename = "elements.json") {
    if (!cy) return;
    const jsons = cy.elements().jsons(); // [{data, position, ...}, ...]
    triggerDownloadJson(jsons, filename);
  }

  // full cy.json() (includes pan/zoom/style/etc.)
  function downloadCyFullJson(cy, filename = "cy.json") {
    if (!cy) return;
    const full = cy.json();
    triggerDownloadJson(full, filename);
  }

  /* ------------------------ Cytoscape -> GraphML ------------------------ */

  // Best: use cytoscape-graphml extension if present (cy.graphml())
  function downloadCyGraphML(cy, filename = "graph.graphml") {
    if (!cy) return;

    // If plugin exists
    if (typeof cy.graphml === "function") {
      const graphml = cy.graphml();
      triggerDownloadText(graphml, filename, "application/xml;charset=utf-8");
      return;
    }

    // Fallback: minimal GraphML
    const graphml = elementsToGraphML(cy.elements().jsons());
    triggerDownloadText(graphml, filename, "application/xml;charset=utf-8");
  }

  /* ------------------------ Elements Prop -> JSON ------------------------ */

  function downloadElementsJson(elements, filename = "elements.json") {
    triggerDownloadJson(elements || [], filename);
  }

  /* ------------------------ Elements Prop -> GraphML ------------------------ */

  // Accepts either:
  //  - Cytoscape elements array: [{ data:{id,...} }, { data:{id,source,target,...} }]
  //  - cy.elements().jsons() array: [{ data:{...}, position:{...}, ... }]
  function downloadElementsGraphML(elements, filename = "graph.graphml") {
    const graphml = elementsToGraphML(elements || []);
    triggerDownloadText(graphml, filename, "application/xml;charset=utf-8");
  }

  // Minimal GraphML writer (good enough for nodes/edges + data keys)
  function elementsToGraphML(elements) {
    const esc = (s) =>
      String(s ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");

    // Detect nodes/edges
    const nodes = [];
    const edges = [];

    for (const ele of elements) {
      const d = ele?.data || {};
      const hasEdge = d.source !== undefined && d.target !== undefined;
      if (hasEdge) edges.push(ele);
      else if (d.id !== undefined) nodes.push(ele);
    }

    // Collect keys (GraphML requires declaring keys up front)
    const nodeKeys = new Set();
    const edgeKeys = new Set();

    nodes.forEach((n) => Object.keys(n.data || {}).forEach((k) => nodeKeys.add(k)));
    edges.forEach((e) => Object.keys(e.data || {}).forEach((k) => edgeKeys.add(k)));

    // Ensure required fields are present
    nodeKeys.delete("id"); // id is attribute on <node>
    edgeKeys.delete("id"); // id is attribute on <edge>
    edgeKeys.delete("source");
    edgeKeys.delete("target");

    const keyDecls = [];

    // node keys
    [...nodeKeys].sort().forEach((k) => {
      keyDecls.push(
        `<key id="n_${esc(k)}" for="node" attr.name="${esc(k)}" attr.type="string"/>`
      );
    });

    // edge keys
    [...edgeKeys].sort().forEach((k) => {
      keyDecls.push(
        `<key id="e_${esc(k)}" for="edge" attr.name="${esc(k)}" attr.type="string"/>`
      );
    });

    // Optional: preserve x/y positions if present
    const hasPos = nodes.some((n) => n.position || n.renderedPosition);
    if (hasPos) {
      keyDecls.push(`<key id="n_x" for="node" attr.name="x" attr.type="double"/>`);
      keyDecls.push(`<key id="n_y" for="node" attr.name="y" attr.type="double"/>`);
    }

    const nodeXml = nodes
      .map((n) => {
        const d = n.data || {};
        const id = esc(d.id);

        const dataXml = [];

        // data fields
        for (const k of [...nodeKeys].sort()) {
          const v = d[k];
          if (v === undefined) continue;
          dataXml.push(`<data key="n_${esc(k)}">${esc(v)}</data>`);
        }

        // position fields (if present)
        if (hasPos) {
          const p = n.position || n.renderedPosition;
          if (p && Number.isFinite(p.x) && Number.isFinite(p.y)) {
            dataXml.push(`<data key="n_x">${p.x}</data>`);
            dataXml.push(`<data key="n_y">${p.y}</data>`);
          }
        }

        return `<node id="${id}">${dataXml.join("")}</node>`;
      })
      .join("");

    const edgeXml = edges
      .map((e) => {
        const d = e.data || {};
        const id = esc(d.id);
        const source = esc(d.source);
        const target = esc(d.target);

        const dataXml = [];
        for (const k of [...edgeKeys].sort()) {
          const v = d[k];
          if (v === undefined) continue;
          dataXml.push(`<data key="e_${esc(k)}">${esc(v)}</data>`);
        }

        // If you want to also include the connection type always:
        // dataXml.push(`<data key="e_connection">${esc(d.connection || "")}</data>`);

        return `<edge id="${id}" source="${source}" target="${target}">${dataXml.join("")}</edge>`;
      })
      .join("");

    return `<?xml version="1.0" encoding="UTF-8"?>
  <graphml xmlns="http://graphml.graphdrawing.org/xmlns"
          xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
          xsi:schemaLocation="http://graphml.graphdrawing.org/xmlns
                              http://graphml.graphdrawing.org/xmlns/1.0/graphml.xsd">
    ${keyDecls.join("\n  ")}
    <graph id="G" edgedefault="undirected">
      ${nodeXml}
      ${edgeXml}
    </graph>
  </graphml>`;
  }
  // Edge-type priority: earlier => closer ring
  const EDGE_TYPE_RINGS = [
    "kmeans",   // ring 1
    "subject",  // ring 2 (change to your actual values)
    "group"     // ring 3
  ];
  function getNotHiddenSubgraph(cy) {
    // "visible()" covers cy.hide() and style display/visibility/opacity effects
    const nodes = cy.nodes().filter(n => n.visible());

    // include only edges whose endpoints are visible
    const edges = cy.edges().filter(e => e.source().visible() && e.target().visible());

    return nodes.union(edges);
  }

  function runFcoseOnNotHidden(cy, params) {
    if (!cy) return;

    // stop any currently running layout
    cy.stop();

    const eles = getNotHiddenSubgraph(cy);

    // If nothing is visible, no-op
    if (eles.empty()) return;

    // Run layout only on the visible subgraph
    const layout = eles.layout({
      name: "fcose",
      quality: "default",
      nodeDimensionsIncludeLabels: true,
      refresh: 30,
      fit: true,        // fits the viewport to the laid out visible eles
      padding: 10,
      randomize: true,
      nodeRepulsion: params.layout.nodeRepulsion,
      idealEdgeLength: params.layout.idealEdgeLength,
      edgeElasticity: 0.45,
      nestingFactor: 0.1,
      gravity: params.layout.gravity,
      numIter: 100000,
      animate: false,
      gravityRangeCompound: 1.5,
      gravityCompound: 1.0,
      gravityRange: 3.8,
      initialEnergyOnIncremental: 0.5,
    });

    layout.run();
  }
  function getVisibleSubgraph(cy) {
    // nodes that are actually rendered (not hidden by style or cy.hide())
    const visNodes = cy.nodes().filter(n => n.visible());

    // only edges that connect two visible nodes
    const visEdges = cy.edges().filter(e => e.source().visible() && e.target().visible());

    return visNodes.union(visEdges);
  }
  function getInViewportSubgraph(cy) {
    const vb = cy.extent(); // model coords of current viewport
    const inViewNodes = cy.nodes().filter(n => {
      const bb = n.boundingBox(); // model coords
      return !(bb.x2 < vb.x1 || bb.x1 > vb.x2 || bb.y2 < vb.y1 || bb.y1 > vb.y2);
    });

    const inViewEdges = cy.edges().filter(e => inViewNodes.contains(e.source()) && inViewNodes.contains(e.target()));
    return inViewNodes.union(inViewEdges);
  }

// Build a deterministic radial-by-edge-type layout object
  function makeEdgeTypeRadialLayout(cy, {
    centerSelector = 'node[type = "kmeans"]', // your kmeans centers
    baseRadius = 0,        // ring0 radius (centers)
    ringStep = 260,        // distance between rings
    startAngle = 0,        // radians
    clockwise = true,
    fit = true,
    padding = 30,
    animate = false
  } = {}) {

    const centers = cy.$(centerSelector);
    const centerIds = new Set(centers.map(n => n.id()));

    // Multi-source assignment: best ring per node based on edge type priority
    // We assign a node to the smallest ring index it can be reached by via edges of that type
    function computeRingIndex() {
      const ringById = new Map();

      // ring 0: centers
      centers.forEach(c => ringById.set(c.id(), 0));

      // For each edge type, do a BFS frontier expansion from anything already assigned <= current ring
      // This yields "concentric by edge type" in the order of EDGE_TYPE_RINGS.
      let frontier = centers; // start from centers

      EDGE_TYPE_RINGS.forEach((etype, i) => {
        const ring = i + 1; // ring 1..N

        // expand from any node already assigned <= ring-1 through edges of this etype
        // (repeat until no new nodes added for this ring)
        let changed = true;
        while (changed) {
          changed = false;

          const sources = cy.nodes().filter(n => ringById.has(n.id()) && ringById.get(n.id()) <= ring - 1);
          sources.forEach(src => {
            const edges = src.connectedEdges().filter(e => e.data("connection") === etype);
            edges.forEach(e => {
              const other = e.source().id() === src.id() ? e.target() : e.source();
              const oid = other.id();

              // Don’t reassign centers; keep them at ring 0
              if (centerIds.has(oid)) return;

              // Assign if unassigned, or if this ring is closer
              if (!ringById.has(oid) || ring < ringById.get(oid)) {
                ringById.set(oid, ring);
                changed = true;
              }
            });
          });
        }
      });

      // Anything still unassigned goes to an outer ring
      const fallbackRing = EDGE_TYPE_RINGS.length + 1;
      cy.nodes().forEach(n => {
        if (!ringById.has(n.id())) ringById.set(n.id(), fallbackRing);
      });

      return ringById;
    }
    

    // Simple, fast ordering within each ring:
    // 1) group by nearest center (by direct kmeans edge if present), else by id
    // 2) within that, sort by degree to reduce crossings somewhat
    function computeAngularOrder(ringById) {
      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

      function centerKeyFor(node) {
        // Primary: kmeans edge
        const kEdge = node.connectedEdges().filter(e => e.data("connection") === "kmeans").first();
        if (kEdge && !kEdge.empty()) {
          const other = kEdge.source().id() === node.id() ? kEdge.target() : kEdge.source();
          if (other.data("type") === "kmeans") return other.id();
        }

        // Secondary: any neighboring kmeans node
        const kNbr = node.neighborhood("node").filter(n => n.data("type") === "kmeans").first();
        if (kNbr && !kNbr.empty()) return kNbr.id();

        return "zz_unassigned";
      }

      // stable center order by label K1, K2, K10...
      function centerSortKey(centerId) {
        const n = cy.$id(centerId);
        const label = n && n.nonempty() ? (n.data("label") ?? centerId) : centerId;
        return String(label);
      }
      const byRing = new Map();
      cy.nodes().forEach(n => {
        const r = ringById.get(n.id());
        if (!byRing.has(r)) byRing.set(r, []);
        byRing.get(r).push(n);
      });

      const orderById = new Map();

      byRing.forEach((nodes, ring) => {
        if (ring === 0) {
  // centers: deterministic order by label "K1, K2, ..." (numeric-aware)
          const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

          nodes.sort((a, b) => {
            const la = String(a.data("label") ?? a.id());
            const lb = String(b.data("label") ?? b.id());
            return collator.compare(la, lb);
          });
        } else {
          // group nodes by their owning kmeans center
          const groups = new Map(); // centerId -> nodes[]
          nodes.forEach(n => {
            const ck = centerKeyFor(n);
            if (!groups.has(ck)) groups.set(ck, []);
            groups.get(ck).push(n);
          });

          // order centers deterministically (K1, K2, ...)
          const centerIds = Array.from(groups.keys()).sort((a, b) =>
            collator.compare(centerSortKey(a), centerSortKey(b))
          );

          // within each center group: degree then id (stable)
          const ordered = [];
          centerIds.forEach(cid => {
            const arr = groups.get(cid);
            arr.sort((a, b) => {
              const da = a.degree(false), db = b.degree(false);
              if (da !== db) return db - da;
              return a.id().localeCompare(b.id(), undefined, { numeric: true, sensitivity: "base" });
            });
            ordered.push(...arr);
          });

          // overwrite ring ordering with grouped ordering
          nodes.length = 0;
          nodes.push(...ordered);
        }

        nodes.forEach((n, idx) => orderById.set(n.id(), { ring, idx, count: nodes.length }));
      });

      return orderById;

      function nearestCenterId(node) {
        // If connected to a kmeans center via kmeans edge, use that center id
        const kEdge = node.connectedEdges().filter(e => e.data("connection") === "kmeans").first();
        if (kEdge && !kEdge.empty()) {
          const other = kEdge.source().id() === node.id() ? kEdge.target() : kEdge.source();
          if (other.data("type") === "kmeans") return other.id();
        }
        // else: any neighboring kmeans node
        const kNbr = node.neighborhood("node").filter(n => n.data("type") === "kmeans").first();
        if (kNbr && !kNbr.empty()) return kNbr.id();

        return "zz_unassigned";
      }
    }

    const ringById = computeRingIndex();
    const orderById = computeAngularOrder(ringById);

    // The actual layout object Cytoscape expects
    return {
      name: "preset",
      fit,
      padding,
      animate,
      animationDuration: animate ? 500 : 0,

      positions: function (node) {
        const { ring, idx, count } = orderById.get(node.id());

        // radius per ring
        const r = baseRadius + ring * ringStep;

        // angle per ring (spread evenly)
        const t = count > 0 ? (idx / count) : 0;
        const theta = startAngle + (clockwise ? 1 : -1) * (2 * Math.PI * t);

        // ring 0: optionally spread centers on a small circle rather than all at origin
        if (ring === 0) {
          const centerR = Math.max(1, ringStep * 0.4);
          return {
            x: centerR * Math.cos(theta),
            y: centerR * Math.sin(theta)
          };
        }

        return {
          x: r * Math.cos(theta),
          y: r * Math.sin(theta)
        };
      }
    };
  }

  // USAGE:
  const defaultLayout = cyInstance ? makeEdgeTypeRadialLayout(cyInstance, {
    // Update if your edge connection labels differ:
    // EDGE_TYPE_RINGS: ["kmeans", "subject", "group"]
    ringStep: 10000,
    padding: 30,
    fit: true,
    animate: false
  }) : { name: "preset", fit: true, padding: 30, animate: false };


  const defaultfCoseLayout = {
    name: "fcose",
    quality: "default",
    nodeDimensionsIncludeLabels: true,
    refresh: 30,
    fit: true,
    padding: 10,
    randomize: true,
    nodeRepulsion: params.layout.nodeRepulsion,
    idealEdgeLength: params.layout.idealEdgeLength,
    edgeElasticity: 0.45,
    nestingFactor: 0.1,
    gravity: params.layout.gravity,
    numIter: 100000,
    animate: false,
    gravityRangeCompound: 1.5,
    gravityCompound: 1.0,
    gravityRange: 3.8,
    initialEnergyOnIncremental: 0.5,
  };
  // const defaultLayout = {
  //   name: "spread",
  //   animate: false, // Whether to show the layout as it's running
  //   ready: undefined, // Callback on layoutready
  //   stop: undefined, // Callback on layoutstop
  //   fit: true, // Reset viewport to fit default simulationBounds
  //   minDist: 120, // Minimum distance between nodes
  //   padding: 80, // Padding
  //   expandingFactor: 1.25, // If the network does not satisfy the minDist
  //   // criterium then it expands the network of this amount
  //   // If it is set to -1.0 the amount of expansion is automatically
  //   // calculated based on the minDist, the aspect ratio and the
  //   // number of nodes
  //   prelayout: { name: 'fcose' }, // Layout options for the first phase
  //   maxExpandIterations: 20, // Maximum number of expanding iterations
  //   boundingBox: undefined, // Constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
  //   randomize: true // Uses random initial node positions on true
  // };
  const STUDENTDATA_COLUMNS = [
    "hasClasses",
    "classCorrelation",
    "progressSlope",
    "termsAttended",
    "unitsAttempted",
    "unitsPassed",
    "passRate",
    "avgPassedPerTerm",
    "avgBenefitUtil",
    "projectedBenefitUtil",
    "aboveOrBelowGrade",
    "totalGPA",
    "percentile",
    "composite",
  ];
  function buildStudentDataIndex(studentData) {
    const map = new Map();
    for (const row of studentData || []) {
      const id = row?.studentID ?? row?.studentId ?? row?.id;
      if (id === null || id === undefined) continue;

      // Normalize to string so it matches your other ids
      map.set(String(id), row);
    }
    return map;
  }
  function pickStudentDataFields(studentDataRow) {
    const out = {};
    for (const k of STUDENTDATA_COLUMNS) out[k] = safe(studentDataRow?.[k]);
    return out;
  }
  function downloadCsv({ mode, scope }) {
    if (!summary) return;

    // Build studentData index once per download, not inside loops
    const studentDataById = buildStudentDataIndex(studentData); // <-- your array

    // NEW: all-students export
    if (mode === "students" && scope === "all") {
      const out = buildAllStudentsRows({ studentDataById });
      const csv = toCsv(out.rows, out.columns);
      triggerDownload(csv, `students_all.csv`);
      return;
    }

    const keyMap = { groups: "groups", subjects: "subjects", kmeans: "kmeans" };
    const listKey = keyMap[mode];
    const items = summary?.[listKey] || [];
    if (!Array.isArray(items) || items.length === 0) return;

    if (scope === "compiled") {
      const compiled = buildCompiledStudentRows({ mode, items, studentDataById });
      triggerDownload(toCsv(compiled.rows, compiled.columns), `${mode}_all.csv`);
      return;
    }

    if (scope === "partitioned") {
      const partitions = buildPartitionedStudentRows({ mode, items, studentDataById });
      for (const part of partitions) {
        triggerDownload(toCsv(part.rows, part.columns), part.filename);
      }
      return;
    }

    if (scope === "dataset") {
      const dataset = buildDatasetRows({ mode, items });
      triggerDownload(toCsv(dataset.rows, dataset.columns), `${mode}_dataset.csv`);
      return;
    }
  }
  function buildCompiledStudentRows({ mode, items, studentDataById }) {
    const baseColumns = ["studentId", "group", "subject", "kmeans"];
    const columns = [...baseColumns, ...STUDENTDATA_COLUMNS];

    const rows = [];
    for (const item of items) {
      const itemId = item.id ?? item.name ?? item.clusterId ?? "";
      const students = item.students || [];

      for (const s of students) {
        const meta = getStudentMeta(s.id);
        const sd = studentDataById?.get(String(s.id)); // <-- match key type

        rows.push({
          studentId: safe(s.id),
          studentColor: safe(s.color),
          group: safe(mode === "groups" ? itemId : meta.group),
          subject: safe(mode === "subjects" ? itemId : meta.subject),
          kmeans: safe(mode === "kmeans" ? itemId : meta.kmeans),

          // appended studentData fields
          ...pickStudentDataFields(sd),
        });
      }
    }

    return { columns, rows };
  }

  function buildAllStudentsRows({ studentDataById }) {
    const baseColumns = ["studentId", "group", "subject", "kmeans"];
    const columns = [...baseColumns, ...STUDENTDATA_COLUMNS];

    const byId = new Map();

    const ingest = (arr) => {
      for (const item of arr || []) {
        for (const s of item.students || []) {
          if (!byId.has(s.id)) byId.set(s.id, { id: s.id, color: s.color ?? "" });
        }
      }
    };

    ingest(summary.groups);
    ingest(summary.subjects);
    ingest(summary.kmeans);

    const groupOf = new Map();
    for (const g of summary.groups || []) {
      for (const s of g.students || []) groupOf.set(s.id, g.id);
    }

    const subjectOf = new Map();
    for (const sub of summary.subjects || []) {
      const sid = sub.id ?? sub.name ?? "";
      for (const s of sub.students || []) subjectOf.set(s.id, sid);
    }

    const kmeansOf = new Map();
    for (const c of summary.kmeans || []) {
      const cid = c.id ?? c.clusterId ?? c.name ?? "";
      for (const s of c.students || []) kmeansOf.set(s.id, cid);
    }

    const rows = [];
    for (const s of byId.values()) {
      const meta = getStudentMeta(s.id);
      const sd = studentDataById?.get(String(s.id));

      rows.push({
        studentId: safe(s.id),
        studentColor: safe(s.color),
        group: safe(meta.group || groupOf.get(s.id) || ""),
        subject: safe(meta.subject || subjectOf.get(s.id) || ""),
        kmeans: safe(meta.kmeans || kmeansOf.get(s.id) || ""),

        ...pickStudentDataFields(sd),
      });
    }

    rows.sort((a, b) => {
      const na = Number(a.studentId);
      const nb = Number(b.studentId);

      // If both parse cleanly as numbers, sort numerically
      if (!Number.isNaN(na) && !Number.isNaN(nb)) {
        return na - nb;
      }

      // Fallback to string sort if either is non-numeric
      return String(a.studentId).localeCompare(String(b.studentId));
    });
    return { columns, rows };
  }
  function buildPartitionedStudentRows({ mode, items, studentDataById }) {
    const baseColumns = ["studentId", "group", "subject", "kmeans"];
    const columns = [...baseColumns, ...STUDENTDATA_COLUMNS];

    return items.map((item) => {
      const itemId = item.id ?? item.name ?? item.clusterId ?? "unknown";
      const students = item.students || [];

      const rows = students.map((s) => {
        const meta = getStudentMeta(s.id);
        const sd = studentDataById?.get(String(s.id));

        return {
          studentId: safe(s.id),
          studentColor: safe(s.color),
          group: safe(mode === "groups" ? itemId : meta.group),
          subject: safe(mode === "subjects" ? itemId : meta.subject),
          kmeans: safe(mode === "kmeans" ? itemId : meta.kmeans),

          ...pickStudentDataFields(sd),
        };
      });

      return {
        filename: `${mode}_${safe(itemId)}.csv`,
        columns,
        rows,
      };
    });
  }
  function buildDatasetRows({ mode, items }) {
    // Adjust based on what exists on the dataset objects:
    // For example: { id, size, centroid, label, avgGpa, ... }
    const columns = ["id", "name", "studentCount"];

    const rows = items.map((item) => ({
      id: safe(item.id ?? ""),
      name: safe(item.name ?? ""),
      studentCount: safe((item.students && item.students.length) || item.studentCount || 0),
    }));

    return { columns, rows };
  }
  /** CSV helpers */
  function safe(v) {
  return v === null || v === undefined ? "" : String(v);
}

/**
 * Update these mappings to match your real `studentProfile.current[studentId]` shape.
 * The goal: return { group, subject, kmeans } for ANY studentId.
 */
function getStudentMeta(studentId) {
  const p = studentProfile?.current?.[studentId] || {};
  return {
    group: p.group ?? p.groupId ?? "",
    subject: p.subject ?? p.subjectId ?? p.subjectName ?? "",
    kmeans: p.kmeans ?? p.cluster ?? p.clusterId ?? "",
  };
}

function toCsv(rows, columns) {
  const escapeCell = (value) => {
    const s = value === null || value === undefined ? "" : String(value);
    if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };

  const header = columns.map(escapeCell).join(",");
  const body = rows.map((r) => columns.map((c) => escapeCell(r[c])).join(",")).join("\n");
  return `${header}\n${body}\n`;
}

function triggerDownload(csvString, filename) {
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
}
  const addLog = (m) => setLogs((p) => [...p, m]);

  const runLayout = () => { if(cyInstance){ cyInstance.layout(defaultLayout).run(); addLog("Layout recalculated."); } };
  /**
   * Toggle the visibility of a connection layer on the Cytoscape graph.
   *
   * HOW IT WORKS
   * 1) Flip the boolean in React state for the given `key` (e.g., "kmeans", "similarity", "subject", etc.).
   * 2) Apply the change to the live Cytoscape instance by showing/hiding all elements whose
   *    data attribute `connection` matches that key.
   * 3) If the key is "kmeans", reposition clusters in a ring layout (cosmetic reflow).
   *
   * NOTES
   * - We use cy.batch() to apply DOM-like style updates in a single, efficient batch.
   * - We set `display` to "element" (show) or "none" (hide) rather than removing elements, so they’re cheap to re-show.
   */
  const toggleVisibility = (key) => {
    // Safety: empty/invalid keys do nothing
    if (typeof key !== "string" || key.length === 0) {
      // Optional: console.warn("toggleVisibility: invalid key", key);
      return;
    }

    // Update the React visibility map atomically
    setVisibility((prevVisibility) => {
      // Flip just the requested flag, keep others identical
      const willShow = !prevVisibility[key];
      const nextVisibility = { ...prevVisibility, [key]: willShow };

      // If we have a live Cytoscape instance, apply the style change efficiently
      if (cyInstance && !cyInstance.destroyed()) {
        // Select all elements (nodes/edges) with data attribute: connection = key
        // e.g., elements('[connection = "kmeans"]')
        const layerSelector = `[connection = "${key}"]`;

        cyInstance.batch(() => {
          cyInstance
            .elements(layerSelector)
            .style({
              // Cytoscape uses "element" to mean visible; "none" to hide (like CSS display)
              display: willShow ? "element" : "none",
            });
        });
      }
      // Return the new state to React
      return nextVisibility;
    });
  };
  const handleSearch = () => {
    if(!cyInstance || !searchValue) return;
    const target = cyInstance.$(`#${searchValue}`);
    if(target.length===0){ addLog(`Search failed: Node "${searchValue}" not found.`); return; }
    cyInstance.nodes().removeClass("highlight");
    target.addClass("highlight");
    cyInstance.animate({ center:{eles:target}, zoom:2 });
    addLog(`Zoomed to node: ${searchValue}`);
  };

  const handleNthNeighbor = (ele, n = 1) => {
    if (!cyInstance) return;

    const selected = cyInstance.$(':selected').filter('node');
    const start = selected.length > 0 ? selected : cyInstance.$(ele).filter('node');

    if (!start || start.length === 0) {
      addLog('Select a node first.');
      return;
    }

    // Recursive helper: nodes at EXACT distance k
    const nthNeighbors = (nodes, k) => {
      if (k <= 0) return nodes;
      const next = nodes.neighborhood('node');
      if (next.length === 0) return cyInstance.collection(); // empty
      return nthNeighbors(next, k - 1);
    };

    const nthBase = nthNeighbors(start, n);

    // ✅ Include the selected/start node(s) with nth nodes
    const nthWithStart = nthBase.union(start);

    // Use nthWithStart everywhere below
    const edges = nthWithStart.connectedEdges();

    cyInstance.batch(() => {
      cyInstance.elements().removeClass('highlight').show();

      start.addClass('highlight');
      nthBase.addClass('highlight');          // keep visual distinction if you want
      edges.addClass('highlight');

      const keep = nthWithStart.union(edges);
      cyInstance.elements().difference(keep).hide();
    });

    addLog(`Selected ${nthBase.length} neighbor(s) at distance ${n}.`); // count remains "exactly n"

    // Filter by type on the combined set
    const students = nthWithStart.filter('node[type = "student"]');
    const groups   = nthWithStart.filter('node[type = "group"]');
    const kmeans   = nthWithStart.filter('node[type = "kmeans"]');
    const subjects = nthWithStart.filter('node[type = "subject"]');
    const subjectsNodeArray = [];
    subjects.forEach(ele => subjectsNodeArray.push(ele.data('label') || ele.id()));
    if (subjects.length > 0)
      addLog("Subject Nodes: " + subjectsNodeArray.join(", "));

    const kmeansNodeArray = [];
    kmeans.forEach(ele => kmeansNodeArray.push(ele.data('label') || ele.id()));
    if (kmeans.length > 0) 
      addLog("K-Means Nodes: " + kmeansNodeArray.join(", "));

    const groupNodeArray = [];
    groups.forEach(ele => groupNodeArray.push(ele.data('label') || ele.id()));
    if (groups.length > 0) 
      addLog("Group Nodes: " + groupNodeArray.join(", "));

    const studentNodeArray = [];
    students.forEach(ele => {
      const id = ele.id();
      studentNodeArray.push(
        <StudentButton
          key={id}
          id={id}
          studentProfile={studentProfile.current[id]}
          backgroundColor={ele.data('color') || 'white'}
        />
      );
    });
    addLog(studentNodeArray);

    return nthWithStart; // optional: expose combined collection
  };
    // Drop-in: Select neighbors at EXACT distance n without removing/hiding anything
    // Usage in menu:
    // { content: "Select Neighbors", select: (ele) => selectNthNeighbor(ele, nthNeighbor) }

    function selectNthNeighbor(ele, n = 1, {
      includeStart = true,
      selectEdges = true,
      edgesBetweenOnly = false
    } = {}) {
      const cy = (typeof cyInstance !== 'undefined' && cyInstance) ? cyInstance : (ele && ele.cy && ele.cy());
      if (!cy) return;

      const currentlySelected = cy.$(':selected').filter('node');
      const start = currentlySelected.length > 0 ? currentlySelected : cy.$(ele).filter('node');

      if (!start || start.length === 0) {
        if (typeof addLog === 'function') addLog('Select a node first.');
        return;
      }

      // BFS layering to get EXACT distance n
      let layer = start;           // distance 0
      let visited = start.clone(); // seen nodes so far

      for (let k = 1; k <= n; k++) {
        const next = layer.neighborhood('node').subtract(visited);
        layer = next;
        visited = visited.union(next);
        if (layer.length === 0) break;
      }

      const nthBase = n <= 0 ? start.clone() : layer;
      if (nthBase.length === 0) {
        if (typeof addLog === 'function') addLog(`No neighbors at distance ${n}.`);
        return cy.collection();
      }

      const nthWithStart = includeStart ? nthBase.union(start) : nthBase;

      // ✅ Only add to selection; do not clear anything
      nthWithStart.select();

      if (selectEdges) {
        let edges;
        if (edgesBetweenOnly) {
          const keepNodes = visited.union(nthBase);
          edges = cy.edges().filter(e => keepNodes.has(e.source()) && keepNodes.has(e.target()));
        } else {
          edges = nthWithStart.connectedEdges();
        }
        edges.select();
      }

      if (typeof addLog === 'function') {
        addLog(`Selected ${nthBase.length} neighbor(s) at distance ${n}.`);

        const students = nthWithStart.filter('node[type = "student"]');
        const groups   = nthWithStart.filter('node[type = "group"]');
        const kmeans   = nthWithStart.filter('node[type = "kmeans"]');
        const subjects = nthWithStart.filter('node[type = "subject"]');

        // FIX: map already returns an array; don't chain .toArray()
        const arrFrom = (col, get = (x)=> x.data('label') || x.id()) =>
          col.map(get);

        if (subjects.length > 0) addLog("Subject Nodes: " + arrFrom(subjects).join(", "));
        if (kmeans.length  > 0) addLog("K-Means Nodes: " + arrFrom(kmeans).join(", "));
        if (groups.length  > 0) addLog("Group Nodes: " + arrFrom(groups).join(", "));

        // If rendering StudentButtons:
        if (typeof React !== 'undefined' && typeof StudentButton !== 'undefined' && studentProfile?.current) {
          // FIX: Use toArray() first, then map to React elements
          const studentButtons = students.toArray().map(ele => {
            const id = ele.id();
            return (
              <StudentButton
                key={id}
                id={id}
                studentProfile={studentProfile.current[id]}
                backgroundColor={ele.data('color') || 'white'}
              />
            );
          });
          if (studentButtons.length > 0) addLog(studentButtons);
        }
      }

      return nthWithStart;
    }


  const applySimilarityThreshold = () => {
    if(!cyInstance) return;
    const t = params.similarityThreshold;
    cyInstance.batch(()=>{
      cyInstance.$(`edge[connection = "similarity"]`).forEach(e=>{
        const v = e.data("similarityVal");
        e.style("display", (typeof v==="number" && v>=t && visibility.similarity) ? "element" : "none");
      });
    });
  };
  // --- K-Means isolation helpers ---------------------------------------------

  // ---------- Generic group isolation utilities (Cytoscape) -------------------

  /**
   * Safely read a group list from summary using a key alias.
   * e.g. getGroup(summary, 'kmeans', 2) or getGroup(summary, 'subjects', 'MATH')
   */
  const getGroup = (summary, groupType, groupId) => {
    const groups = summary?.[groupType] || summary?.[groupType.toLowerCase()] || [];
    return groups.find(g => `${g.id}` === `${groupId}`) || null;
  };

  /**
   * Isolate (show/highlight) only the nodes in a group and edges among them.
   * @param {Object} params
   *  - cy: cytoscape instance
   *  - summary: your summary object
   *  - groupType: 'kmeans' | 'subjects' | ...
   *  - groupId: id of the group to isolate
   *  - options:
   *      highlight: boolean (default: true)
   *      hideOthers: boolean (default: true)
   *      matchBy: 'id' | 'studentId' (default: 'id')
   *      edgeType: string | null (default: infer from groupType: 'kmeans' for kmeans, 'subject' for subjects)
   */
    const isolateGroup = (
      { cy, summary, groupType, groupId },
      {
        highlight = true,
        hideOthers = true,
        matchBy = 'id',
        edgeType = null,       // keep all edge types by default
        keepIncident = false,  // keep edges to outside neighbors, too
        // --- new zoom options ---
        fit = true,            // auto-zoom to collection
        padding = 48,          // pixels of margin around result
        animate = true,        // animate the fit
        duration = 350,        // ms
        easing = 'ease-in-out',
      } = {}
    ) => {
      if (!cy) return null;

      const group = getGroup(summary, groupType, groupId);
      if (!group) return null;

      const memberIds = new Set(group.students.map(s => `${s.id}`));

      const groupNodes = cy.nodes().filter(n => {
        if (matchBy === 'studentId') return memberIds.has(`${n.data('studentId')}`);
        return memberIds.has(`${n.id()}`);
      });

      let edges;
      if (keepIncident) {
        edges = groupNodes.connectedEdges();
      } else {
        edges = cy.edges().filter(e => groupNodes.contains(e.source()) && groupNodes.contains(e.target()));
      }
      if (edgeType) edges = edges.filter(e => e.data('connection') === edgeType);

      const neighbors = keepIncident ? edges.connectedNodes() : cy.collection();

      let keep = cy.collection(); // everything we’ll show/fit
      cy.batch(() => {
        cy.elements().removeClass('highlight').show();

        if (highlight) {
          groupNodes.addClass('highlight');
          edges.addClass('highlight');
          neighbors.addClass('highlight');
        }

        keep = groupNodes.union(edges).union(neighbors);

        if (hideOthers) {
          cy.elements().difference(keep).hide();
        }
      });

      // Zoom to the extent with padding (if there’s anything to show)
      if (fit && keep.nonempty()) {
        if (animate) {
          cy.animate({ fit: { eles: keep, padding }, duration, easing });
        } else {
          cy.fit(keep, padding);
        }
      }

      addLog?.(
        `Isolated ${groupType} ${groupId} — nodes: ${groupNodes.length}, edges: ${edges.length}, neighbors: ${neighbors.length || 0}.`
      );

      return groupNodes;
    };

  const resetIsolation = (cy) => {
    if (!cy) return;
    cy.batch(() => cy.elements().removeClass('highlight').show());
    if (typeof addLog === 'function') addLog('Reset isolation. All elements visible.');
  };

  // // clustering layers
  // const clusterLayerIdsRef = useRef({
  //   cluster_kmeans:new Set(), cluster_components:new Set(), cluster_labelprop:new Set()
  // });
  // const buildClusterLayerElems = (methodKey,labelMap)=>{
  //   if(!cyInstance) return;
  //   const byLabel={}; Object.keys(labelMap).forEach(id=>{ const lab=labelMap[id]; (byLabel[lab]??=[]).push(id); });
  //   const added=[];
  //   let idx=1;
  //   for(const [lab, ids] of Object.entries(byLabel)){
  //     const hueColor = (i)=>`hsl(${(i*57)%360},65%,62%)`;
  //     const groupId = `cluster_${methodKey}_${idx}`;
  //     if(params.clustering.addGroupNodes){
  //       cyInstance.add({ group:"nodes", data:{ id:groupId, type:"group", label:`${methodKey.replace("cluster_","")} ${idx}`, width:50, height:50, color:hueColor(idx), connection:methodKey }});
  //       added.push(groupId);
  //     }
  //     ids.forEach(nid=>{
  //       if(params.clustering.addGroupNodes){
  //         const eid=`${nid}->${groupId}`;
  //         cyInstance.add({ group:"edges", data:{ id:eid, source:nid, target:groupId, width:4, color:hueColor(idx), label:`${methodKey.replace("cluster_","")} ${idx}`, connection:methodKey, classes:"autorotate" }});
  //         added.push(eid);
  //       }
  //       if(params.clustering.colorByCluster){ cyInstance.$id(nid).data("color", hueColor(idx)); }
  //       cyInstance.$id(nid).data(`${methodKey}_clusterId`, idx);
  //     });
  //     idx++;
  //   }
  //   added.forEach(id=>clusterLayerIdsRef.current[methodKey].add(id));
  // };
  // const removeClusterLayer = (methodKey)=>{
  //   const ids = clusterLayerIdsRef.current[methodKey];
  //   if(!cyInstance || !ids || ids.size===0) return;
  //   cyInstance.batch(()=>{ ids.forEach(id=>cyInstance.$id(id).remove()); });
  //   ids.clear();
  // };
  // const clusterByComponents = ()=>{
  //   if(!cyInstance) return;
  //   removeClusterLayer("cluster_components");
  //   const comps = cyInstance.elements().components();
  //   const labelMap={};
  //   comps.forEach((comp,idx)=>{ comp.nodes().forEach(n=>{ if(n.data("type")==="student") labelMap[n.id()]=idx+1; }); });
  //   buildClusterLayerElems("cluster_components", labelMap);
  //   arrangeClustersRing(cyInstance,"cluster_components");
  //   setVisibility(v=>({...v, cluster_components:true}));
  //   addLog("Built component clusters.");
  // };
  // const clusterByLabelPropagation = (iters=8)=>{
  //   if(!cyInstance) return;
  //   removeClusterLayer("cluster_labelprop");
  //   const students = cyInstance.nodes('[type = "student"]');
  //   const labels={}; students.forEach((n,i)=>labels[n.id()]=i+1);
  //   for(let t=0;t<iters;t++){
  //     students.forEach(n=>{
  //       const counts={};
  //       n.neighborhood("node").forEach(m=>{ const lab=labels[m.id()]; if(lab) counts[lab]=(counts[lab]||0)+1; });
  //       let best=labels[n.id()], bestC=-1;
  //       Object.entries(counts).forEach(([lab,c])=>{ const L=Number(lab); if(c>bestC || (c===bestC && L<best)){ best=L; bestC=c; } });
  //       if(bestC>=0) labels[n.id()]=best;
  //     });
  //   }
  //   buildClusterLayerElems("cluster_labelprop", labels);
  //   arrangeClustersRing(cyInstance,"cluster_labelprop");
  //   setVisibility(v=>({...v, cluster_labelprop:true}));
  //   addLog("Built label-propagation clusters.");
  // };
  // const clusterByKMeansSimilarity = (K=6)=>{
  //   if(!cyInstance) return;
  //   removeClusterLayer("cluster_kmeans");
  //   const store = featureVectors?.[featureMode];
  //   if(!store){ addLog(`No feature vectors for mode "${featureMode}".`); return; }
  //   const ids = cyInstance.nodes('[type = "student"]').map(n=>n.id());
  //   const data=[], kept=[];
  //   for(const id of ids){ const v=store[id]; if(Array.isArray(v)&&v.length){ data.push(v); kept.push(id); } }
  //   if(data.length===0){ addLog("No vectors for current students."); return; }
  //   const {labels} = kmeansVectors(data, Math.min(K,data.length), cosineDistance, 60);
  //   const map={}; kept.forEach((id,i)=>map[id]=labels[i]+1);
  //   buildClusterLayerElems("cluster_kmeans", map);
  //   arrangeClustersRing(cyInstance,"cluster_kmeans",{
  //     radius: Math.max(300, Math.min(cyInstance.width(), cyInstance.height())*0.38),
  //     boxW: 220, boxH: 140, jitter: 0.95, rotate: 0
  //   });
  //   setVisibility(v=>({...v, cluster_kmeans:true}));
  //   addLog(`Built K-Means clusters (K=${K}, mode=${featureMode}).`);
  // };
  // const applyClustering = ()=>{
  //   ["cluster_kmeans","cluster_components","cluster_labelprop"].forEach(removeClusterLayer);
  //   const m = params.clustering.method;
  //   if(m==="kmeans")      clusterByKMeansSimilarity(params.clustering.kMeansK);
  //   else if(m==="components") clusterByComponents();
  //   else if(m==="labelprop")  clusterByLabelPropagation(params.clustering.labelPropIters);
  // };
  const resetView = () => {
    if (!cyInstance) return;

    cyInstance.stop(); // stop any running layouts

    cyInstance.batch(() => {
      cyInstance.nodes().show().removeClass("highlight");
      cyInstance.edges().show();

      Object.keys(visibility).forEach((property) => {
        cyInstance
          .elements(`[connection="${property}"]`)
          .style({ display: visibility[property] ? "element" : "none" });
      });

      cyInstance.elements().removeClass("highlight");
    });

    // 🔁 Re-run the original concentric layout
    if (originalLayoutRef.current) {
      cyInstance.layout(originalLayoutRef.current).run();
    }

    addLog("View reset and concentric layout restored.");
  };
  // wire cytoscape
  useEffect(() => {
    if (!cyInstance) return;

    // ✅ Log how many nodes and edges are loaded
    const nodeCount = cyInstance.nodes().length;
    const edgeCount = cyInstance.edges().length;
    addLog(`Cytoscape loaded with ${nodeCount} nodes and ${edgeCount} edges.`);

    // Example: optional visual cue (e.g., first render highlight)
    // cyInstance.nodes().addClass('highlight');

    // Node tap handler
    cyInstance.on("tap", "node", (e) => {
      const id = e.target.id();
      if (e.target.data().type === "student") {
        let studentIndex = id - 1;
        addLog(
          <StudentButton
            id={id}
            studentProfile={studentProfile.current[id]}
            backgroundColor={getGPAColor(studentData[studentIndex].totalGPA)}
          />
        );
      } else addLog(`Tapped node: ${id}`);
    });

    cyInstance.on("cxttapstart", (e) => {
      e.originalEvent.preventDefault();
    });
    function resolveNodeDetails(ele, { studentProfileRef, networkInfo }) {
    const id = ele.id();
    const type = ele.data("type"); // preferred if you set it

    // ---- KMEANS detection (use type if present, else fallback to id prefix) ----
    const isKmeans =
      type === "kmeans" ||
      (typeof id === "string" && id.startsWith("kmeans_"));

    if (isKmeans) {
      // If id is "kmeans_3" -> clusterKey = 3
      const clusterKey = Number(String(id).split("_")[1]);

      return {
        nodeType: "kmeans",
        id,
        clusterKey,
        details: <ClusterDashboard id={clusterKey} cluster={networkInfo.kmeans[clusterKey]} chartColors={chartColors} />,
      };
    }

    // ---- Group detection (optional) ----
    const isGroup =
      type === "group" ||
      (typeof id === "string" && id.startsWith("group_"));

    if (isGroup) {
      const groupKey = Number(String(id).split("_")[1]);
      return {
        nodeType: "group",
        id,
        groupKey,
        details: networkInfo?.groups?.[groupKey] ?? null,
      };
    }

    // ---- Subject detection (optional) ----
    const isSubject = type === "subject";
    if (isSubject) {
      return {
        nodeType: "subject",
        id,
        details: networkInfo?.subjects?.[id] ?? null,
      };
    }

    // ---- Default: student ----
    return {
      nodeType: "student",
      id,
      details: studentProfileRef?.current?.[id] ?? null,
    };
  }
    cyInstance.cxtmenu({
      menuRadius: () => 100,
      selector: "node",
      commands: [
        {
          content: "View Details",
          select: (ele) => {
            const payload = resolveNodeDetails(ele, {
              studentProfileRef: studentProfile,
              networkInfo, // must be in scope
            });
            if (payload.nodeType === "student" && !payload.details) {
              openFloatingModal(payload.id, payload.details, payload.nodeType);
            }
            if (payload.nodeType === "kmeans") {
              openFloatingModal(payload.id, payload.details, payload.nodeType);
            }
            // You can keep your modal API exactly the same; just pass the correct details:
            openFloatingModal(payload.id, payload.details, payload.nodeType);

            // If you prefer separate modals:
            // if (payload.nodeType === "kmeans") openKmeansModal(payload.clusterKey, payload.details);
            // else openFloatingModal(payload.id, payload.details);
          },
        },
        { content: "Isolate Neighbors", select: (ele) => handleNthNeighbor(ele, nthNeighbor) },
      ],
      fillColor: "rgba(0,0,0,0.75)",
      activeFillColor: "rgba(219,219,219,0.75)",
      activePadding: 20,
      indicatorSize: 24,
      separatorWidth: 3,
      spotlightPadding: 4,
      atMouse: false,
      zIndex: 9999
    });

    cyInstance.nodes().selectify().grabify().unlock();
    applySimilarityThreshold();
     if (!cyInstance) return;

    // Build the original concentric layout ONCE
    if (!originalLayoutRef.current) {
      originalLayoutRef.current = makeEdgeTypeRadialLayout(cyInstance, {
        ringStep: 10000,
        padding: 30,
        fit: true,
        animate: false
      });

      // Run it once on initial load
      cyInstance.layout(originalLayoutRef.current).run();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cyInstance]);

  // resize + fit whenever wrapper size changes (modal open/drag)
  useLayoutEffect(()=>{
    if(!cyInstance || !wrapperRef.current) return;
    const resizeAndFit=()=>{
      const r=wrapperRef.current.getBoundingClientRect();
      if(r.width>0 && r.height>0){ cyInstance.resize(); cyInstance.fit(); }
    };
    const ro=new ResizeObserver(resizeAndFit);
    ro.observe(wrapperRef.current);
    resizeAndFit(); requestAnimationFrame(resizeAndFit);
    return ()=>ro.disconnect();
  },[cyInstance]);

  // respond to parameter changes
  useEffect(()=>{ applySimilarityThreshold(); /* eslint-disable-next-line */ },[params.similarityThreshold, visibility.similarity]);
  useEffect(() => {
    if (!cyInstance) return;
    cyInstance.batch(() => {
      Object.entries(visibility).forEach(([key, isOn]) => {
        const eles = cyInstance.elements(`[connection = "${key}"]`);
        isOn ? eles.show() : eles.hide();   // <- apply, not toggle
      });
    });
  }, [cyInstance]); // run once when cy is ready

  // 1) Keep CytoscapeComponent layout prop stable (never changes on re-render)
  const STABLE_LAYOUT = { name: "preset", fit: false };

  // 2) Store your radial layout builder + runner in refs so it won't recreate each render
  const radialLayoutRef = useRef(null);

  useEffect(() => {
    if (!cyInstance) return;

    // Build ONCE (or rebuild only when you truly want to)
    radialLayoutRef.current = makeEdgeTypeRadialLayout(cyInstance, {
      ringStep: 10000,
      padding: 30,
      fit: false,     // IMPORTANT: avoid refit on every run
      animate: false
    });

    // Optional: run it once after cy is ready
    cyInstance.layout(radialLayoutRef.current).run();
  }, [cyInstance]); // <-- only when cyInstance first becomes available

  function runRadialLayout() {
    if (!cyInstance || !radialLayoutRef.current) return;
    cyInstance.stop();
    cyInstance.layout(radialLayoutRef.current).run();
  }

  return (
    <div
      ref={wrapperRef}
      style={{
        position:"relative",
        width:"100%",
        height:"100%",          // graph gets as much space as possible from parent
        background:"#000",
        overflow:"hidden"
      }}
    >
      {/* Cytoscape fills the container */}
      <CytoscapeComponent
        elements={elements}
        layout={STABLE_LAYOUT}
        stylesheet={[
          {
            selector: "node",
            style: {
              "background-color": "data(color)",
              "shape": "data(shape)",                // ← shape parameter (fallback below)
              "label": "data(label)",
              "font-size": "data(labelSize)",         // ← label size parameter
              "text-wrap": "wrap",
              "text-outline-color": "#e8e8e8",
              "text-outline-width": 5,
              "text-valign": "center",
              "text-halign": "center",
              "width": "data(width)",
              "height": "data(height)"
            }
          },
          {
            selector: 'node[shape = ""]',
            style: {
              "shape": "ellipse"                     // fallback if no shape provided
            }
          },
          {
            selector: "edge",
            style: {
              "width": "data(width)",
              "label": "data(label)",
              "font-size": "data(labelSize)",         // ← edge label size (optional)
              "text-rotation": "autorotate",
              "line-color": "data(color)",
              "text-outline-color": "#f5f5f5",
              "text-outline-width": 5,
              "target-arrow-color": "data(color)",
              // "target-arrow-shape": "triangle",
              "target-arrow-width": 1,
              "curve-style": "bezier"
            }
          },
          {
            selector: ".autorotate",
            style: {
              "text-rotation": "autorotate"
            }
          }
        ]}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          display: "block",
          // help Cytoscape own the pointer gestures
          touchAction: "none",
          WebkitUserSelect: "none",
          userSelect: "none",
          overscrollBehavior: "contain",
        }}
        wheelSensitivity={0.2}
        cy={(cy) => {
          cy.minZoom(0.005);
          cy.maxZoom(2);
          setCyInstance(cy);
        }}
      />

      {/* OVERLAYS (do not consume clicks except inside the cards) */}
      <div style={{ position:"absolute", inset:0, zIndex:5, pointerEvents:"none" }}>
        {/* Top toolbar */}
        <div className="ui-card toolbar" style={{ top:8, left:8, right: 8 }}>
          <div className="field">
            <label htmlFor="studentId">Student ID</label>
            <input
              id="studentId"
              type="text"
              value={searchValue}
              onChange={(e)=>setSearchValue(e.target.value)}
              onKeyDown={(e)=>{ if(e.key==="Enter") handleSearch(); }}
              placeholder="Search"
              style={{ width:160, height:28, fontSize:12 }}
            />
          </div>
          <button className="btn btn-primary" onClick={handleSearch}>Search</button>
          <ButtonGroup>
            {/* Primary button (optional default action) */}
            <Button
              variant="primary"
              size="md"
              onClick={() => setPanelOpen(v => !v)}
            >
              Controls
            </Button>

            {/* Split dropdown */}
            <Dropdown as={ButtonGroup}>
              <Dropdown.Toggle
                split
                variant="primary"
                id="controls-dropdown"
              />

              <Dropdown.Menu style={{ minWidth: 360, maxHeight: "40vh", overflowY: "auto" }}>
                <Dropdown.Header>Panels</Dropdown.Header>

                <Dropdown.Item onClick={() => setLogPanelOpen(v => !v)}>
                  {logPanelOpen ? "Close Logs" : "Open Logs"}
                </Dropdown.Item>

                <Dropdown.Item onClick={() => setPanelOpen(v => !v)}>
                  {panelOpen ? "Close Menu" : "Open Menu"}
                </Dropdown.Item>

                <Dropdown.Item onClick={() => setSummaryPanelOpen(v => !v)}>
                  {summaryPanelOpen ? "Close Summary Panel" : "Open Summary Panel"}
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Header>Layout</Dropdown.Header>

                <Dropdown.Item
                  onClick={() => runFcoseOnNotHidden(cyInstance, params)}
                >
                  Run fCose Layout
                </Dropdown.Item>

                <Dropdown.Item onClick={resetView}>
                  Reset View
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </ButtonGroup>
          <Button variant="primary" className="btn btn-primary" size="md" onClick={() => openFloatingModal(
            "Social Connections in 3D",
            <ThreeDGraph
               elements={elements}
              kmeansRingRadius={1400}        // distance between KMeans hubs (group separation)
              childSphereRadius={1420}        // radius of child sphere around each kmeans hub
              labelScale={0.2}
              onNodeClick={(n)=>console.log(n)}
            />
          )}>
                View in 3D
          </Button>
          <ExportDropdown 
            downloadCyFullJson={downloadCyFullJson}
            downloadCyGraphML={downloadCyGraphML}
            downloadCyVisibleElementsJson={downloadCyVisibleElementsJson}
            downloadCyVisibleGraphML={downloadCyVisibleGraphML}
            downloadElementsGraphML={downloadElementsGraphML}
            downloadElementsJson={downloadElementsJson}
            elements={elements} cyInstance={cyInstance} downloadCsv={downloadCsv}/>

        </div>
        {/* Right side summary */}
        <div className="ui-card sidepanel" style={{ right:8, bottom:8, width: summaryPanelOpen ? 400 : 0 }}>
          {summaryPanelOpen && (
            <div className="panel-body">
              <button className="btn btn-close" onClick={()=>setSummaryPanelOpen(false)} style={{ position:"absolute", top:12, right:12, width: "30px", height: "30px" }}><XCircleIcon size="24"/></button>
              <br/>
              <Button variant="primary" className="btn btn-primary" size="md" onClick={()=>setVisibleSummary("groups")}>
                    Groups
              </Button>
              <Button variant="primary" className="btn btn-primary ms-2" size="md" onClick={()=>setVisibleSummary("subjects")}>
                    Subjects
              </Button>
              <Button variant="primary" className="btn btn-primary ms-2" size="md" onClick={()=>setVisibleSummary("kmeans")}>
                    kmeans
              </Button>
              

             {visibleSummary === "groups" && (
              <div>
                {summary["groups"].map((group) => (
                  <div key={group.id}>
                    <h3
                      style={{
                        cursor: "pointer",
                        userSelect: "none",
                        color: groupColors[group.id], // safe index
                      }}
                      title="Click to isolate this group"
                      onClick={() =>
                        isolateGroup(
                          { cy: cyInstance, summary, groupType: "groups", groupId: group.id },
                          {
                            keepIncident: false,
                            edgeType: null,
                            fit: true,
                            padding: 72,
                            duration: 500,
                          }
                        )
                      }
                    >
                      Isolate {`Group ${group.id}`} <HandEyeIcon weight="fill" size={24} />
                    </h3>

                    <button
                      type="button"
                      style={{ marginBottom: 8 }}
                      onClick={() => resetIsolation(cyInstance)}
                    >
                      Reset view
                    </button>
                    <br />

                    {group.students.map((student) => (
                      <StudentButton
                        key={student.id}
                        id={student.id}
                        backgroundColor={student.color}
                        studentProfile={studentProfile.current[student.id]}
                        onClick={() =>
                          isolateGroup(
                            { cy: cyInstance, summary, groupType: "groups", groupId: group.id },
                            {
                              keepIncident: false,
                              edgeType: null,
                              fit: true,
                              padding: 72,
                              duration: 500,
                            }
                          )
                        }
                      />
                    ))}
                  </div>
                ))}
              </div>
            )}

              {visibleSummary === "subjects" && (
                <div>
                  {summary['subjects'].slice().sort((a, b) => String(a.id).localeCompare(String(b.id))).map((group) => (
                    <div key={group.id}>
                      <h3
                        style={{ cursor: 'pointer', userSelect: 'none', color: chartColors[group.id] }}
                        title="Click to isolate this subject group"
                        onClick={() => isolateGroup({ cy: cyInstance, summary, groupType: 'subjects', groupId: group.id }, {
                          keepIncident: false,
                          edgeType: null,
                          fit: true,
                          padding: 72,
                          duration: 500
                        })}
                      >
                        {group.id} <HandEyeIcon weight="fill" size={24} />
                      </h3>

                      <button
                        type="button"
                        style={{ marginBottom: 8 }}
                        onClick={() => resetIsolation(cyInstance)}
                      >
                        Reset view
                      </button><br/>

                      {group.students.map((student) => (
                        <StudentButton
                          key={student.id}
                          id={student.id}
                          backgroundColor={student.color}
                          studentProfile={studentProfile.current[student.id]}
                          onClick={() =>
                            isolateGroup(
                              { cy: cyInstance, summary, groupType: 'subjects', groupId: group.id },
                              {}
                            )
                          }
                        />
                      ))}
                    </div>
                  ))}
                </div>
              )}

             {visibleSummary === "kmeans" && (
              <div>
                {summary['kmeans'].map((group) => (
                  <div key={group.id}>
                    <h3
                      style={{ color: kMeansColors[group.id - 1], cursor: 'pointer', userSelect: 'none' }}
                      title="Click to isolate this cluster"
                      onClick={() => isolateGroup({ cy: cyInstance, summary, groupType: 'kmeans', groupId: group.id }, {
                        keepIncident: false,
                        edgeType: null,
                        fit: true,
                        padding: 72,
                        duration: 500
                      })}

                    >
                      kmeans {group.id} <HandEyeIcon weight="fill" size={24} />
                    </h3>
                  {networkInfo.kmeans[group.id] && <ClusterDashboard id={group.id} cluster={networkInfo.kmeans[group.id]} chartColors={chartColors} />}

                  {/* Optional: a per-group reset */}
                      <button
                      type="button"
                      style={{ marginBottom: 8 }}
                      onClick={() => resetIsolation(cyInstance)}
                    >
                      Reset view
                    </button><br/>

                    {group.students.map((student) => (
                      <StudentButton
                        key={student.id}
                        id={student.id}
                        backgroundColor={student.color}
                        studentProfile={studentProfile.current[student.id]}
                        // Tip: clicking a student can also isolate their cluster
                        onClick={() => isolateGroup({ cy: cyInstance, summary, groupType: 'kmeans', groupId: group.id })}
                      />
                    ))}
                  </div>
                ))}
              </div>
            )}
            </div>
          )}
        </div>

        {/* Right side panel */}
        <div className="ui-card sidepanel" style={{ right:8, bottom:8, width: panelOpen ? 340 : 0 }}>
          {panelOpen && (
            <div className="panel-body">
              {// close icon at top of panel
              }
              <button className="btn btn-close" onClick={()=>setPanelOpen(false)} style={{ position:"absolute", top:12, right:12, width: "30px", height: "30px" }}><XCircleIcon size="24"/></button>
              <h3>Controls</h3>
              <button 
                type="button"
                className="btn-danger"
                style={{ width: "100%" }} 
                onClick={e => { resetView();
                }}
               >Reset View</button>
               
              <h4>Layers</h4>
              <div className="grid2">
                {Object.keys(visibility).map((key)=>(
                  <label key={key} className="chk">
                    <input type="checkbox" checked={visibility[key]} onChange={()=>toggleVisibility(key)} />
                    {key}
                  </label>
                ))}
              </div>

              <hr/>
              <div className="group">
                <label>Similarity threshold: {(params.similarityThreshold*100).toFixed(0)}%</label>
                <input type="range" min={0} max={1} step={0.01}
                  value={params.similarityThreshold}
                  onChange={(e)=>setParams(p=>({...p, similarityThreshold:Number(e.target.value)}))}
                />
                <button className="btn" onClick={applySimilarityThreshold}>Apply</button>
              </div>

              <hr/>
{/* 
              <h4>Layout</h4>
              <div className="grid2">
                <label>Node Repulsion
                  <input type="number" value={params.layout.nodeRepulsion}
                    onChange={(e)=>setParams(p=>({...p, layout:{...p.layout, nodeRepulsion:Number(e.target.value)}}))}
                  />
                </label>
                <label>Ideal Edge Length
                  <input type="number" style={{width: "50px"}} value={params.layout.idealEdgeLength}
                    onChange={(e)=>setParams(p=>({...p, layout:{...p.layout, idealEdgeLength:Number(e.target.value)}}))}
                  />
                </label>
                <label>Gravity
                  <input type="number" step="0.05" value={params.layout.gravity}
                    onChange={(e)=>setParams(p=>({...p, layout:{...p.layout, gravity:Number(e.target.value)}}))}
                  />
                </label>
              </div>
              <button className="btn btn-primary" onClick={runLayout}>Recalculate Layout</button>

              <hr/>
              <h4>Neighbors</h4>
              <div className="grid2">

                <div>
                  <input type="number" min={1} value={nthNeighbor} onChange={(e)=>setNthNeighbor(Number(e.target.value))} style={{ width:70 }} />
                  <button className="btn" onClick={(e)=>handleNthNeighbor(e, nthNeighbor)}>Select Nth</button>
                  <button className="btn" onClick={()=>{ cyInstance?.nodes().show().removeClass("highlight"); cyInstance?.edges().show(); }}>Reset View</button>
                </div>
              </div> */}
              </div>
          )}
        </div>

        {/* Logs (bottom-left overlay) */}
        {logPanelOpen && (
          <LogPanel logs={logs} logPanelOpen={logPanelOpen} />
        )}
      </div>
    </div>
  );
};

export default CyGraph;
